import { useTranslation } from 'react-i18next'
import { Add } from '@mui/icons-material'
import {Fab, Tooltip } from '@mui/material'
import { useField, useFormikContext } from 'formik'
import { IRubricCriterion } from 'types'
import _ from 'lodash'
import { useEffect } from 'react'
import RubricCriterionRow from './RubricCriterionRow'


const RubricCriterionList = ({ fieldProps, disabled, cells=3 }) => {
  const { t } = useTranslation()

  const [field] = useField<IRubricCriterion[]>(fieldProps.name)
  const { setFieldValue } = useFormikContext()

  const handleAddEntity = () => {
    setFieldValue(fieldProps.name, [
      ...field.value,
      {
        title: '',
        description: '',
        points: 0,
        rubric_sections: _.range(cells).map(c => { return {
          title: '',
          points: (c+1)
        }})
      },
    ])
  }


  useEffect(() => {

    const newCriterions = []

    field.value.forEach((rc, rcIdx) => {

      if(rc.rubric_sections.length === cells){
        newCriterions.push({
          ...rc,
        })
      }

      if(rc.rubric_sections.length < cells){
          const moreSections = []
          for(let i=0; i<cells-rc.rubric_sections.length; i++){
            moreSections.push({
              title: '',
              points: (rc.rubric_sections.length+i+1)
            })
          }
          newCriterions.push({
            ...rc,
            rubric_sections: [...rc.rubric_sections, ...moreSections]
          })
      } 
      if(rc.rubric_sections.length > cells){
        const lessSections = rc.rubric_sections.filter((rs, idx) => idx < cells)
        newCriterions.push({
          ...rc,
          rubric_sections: [...lessSections]
        })
      }
    })

    setFieldValue(fieldProps.name, newCriterions);

  }, [cells])


  return (
    <>      
      {field?.value?.length > 0 ? (
        field.value.map((rc: IRubricCriterion, index: number) => (
          <RubricCriterionRow 
            key={index} 
            index={index} 
            fieldProps={fieldProps} 
            rubric_criterion={rc} 
            cells={cells} 
            disabled={disabled} />
        ))
      ) : (
        <></>
      )}

      <Tooltip title={`${t('common.add')}`} arrow placement='top'>
        <Fab
          aria-label='add'
          size='small'
          disabled={disabled}
          onClick={handleAddEntity}
          color='success'
          sx={{ margin: '40px 0px', boxShadow: 'none', width: '200px' }}
        >
          <Add style={{ fontSize: '1.8rem' }} />  {t('common.add-new-criteria')}
        </Fab>
      </Tooltip>
    </>
  )
}

export default RubricCriterionList
